<template>
	<section>
		<!--顶部工具条-->
		<el-col :span="24">
			<el-form :inline="true">
				<el-form-item label="关键字:">
					<el-input
							v-model="filters.keyWord"
							placeholder="编号、姓名、手机号、产品标题"
							clearable
					></el-input>
				</el-form-item>
				
				<!-- 订单类型 -->
				<el-form-item label="订单类型:">
					<el-select v-model="filters.orderType" placeholder="请选择订单类型">
						<el-option
								v-for="item in orderTypeList"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				
				<!-- 是否首次 -->
				<el-form-item label="是否首次:">
					<el-select v-model="filters.isFirst" clearable placeholder="请选择是否首次">
						<el-option
								v-for="item in yesNoList"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				
				<!-- 是否有提成 -->
				<el-form-item label="是否有提成:">
					<el-select v-model="filters.isCommission" clearable placeholder="请选择是否有提成">
						<el-option
								v-for="item in yesNoList"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				
				<!-- 订单来源 -->
				<el-form-item label="订单来源:">
					<el-select v-model="filters.orderSource" clearable placeholder="请选择订单来源">
						<el-option
								v-for="item in orderSourceList"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				
				<!-- 推广人昵称 -->
				<el-form-item label="推广人昵称:">
					<el-input
							v-model="filters.referrerName"
							placeholder="请输入推广人昵称"
							clearable
					></el-input>
				</el-form-item>
				
				<!-- 订单状态 -->
				<el-form-item label="订单状态:">
					<el-select v-model="filters.orderStatus" clearable placeholder="请选择订单状态">
						<el-option
								v-for="item in orderStatusList"
								:key="item.value"
								:label="item.name"
								:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				
				<!-- 日期范围（拆分为 startTime 和 endTime） -->
				<el-form-item label="日期范围:">
					<el-date-picker
							v-model="dateRangePicker"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
							@change="handleDateRangeChange"
					></el-date-picker>
				</el-form-item>
				<el-form-item>
					<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table
				:data="roles"
				border
				highlight-current-row
				v-loading="listLoading"
				@current-change="selectCurrentRow"
				style="width: 100%;"
		>
			<el-table-column type="index" label="序号" width="80" align="center" :index='indexMethod'></el-table-column>
			<el-table-column prop="orderCode" label="订单编号" width="140" align="center"></el-table-column>
			<el-table-column prop="headline" label="产品名称" header-align="center" width="120" align="left" show-overflow-tooltip></el-table-column>
			<el-table-column prop="orderType" label="订单类型" width="100" align="center">
				<template slot-scope="scope">
					<el-tag v-if='scope.row.orderType==1' type='success'>{{'单个产品'}}</el-tag>
					<el-tag v-else-if="scope.row.orderType == 2" type='primary'>{{'合集产品'}}</el-tag>
				</template>
			</el-table-column>
<!--			<el-table-column label="配套文档名称" width="120" align="center"></el-table-column> &lt;!&ndash; 注：返回数据中无对应字段，需后端补充 &ndash;&gt;-->
<!--			<el-table-column label="配套文档权限" width="120" align="center"></el-table-column> &lt;!&ndash; 注：返回数据中无对应字段，需后端补充 &ndash;&gt;-->
			<el-table-column prop="nickName" label="姓名" width="120" align="center"></el-table-column>
			<el-table-column prop="phoneNumber" label="手机号" width="120" align="center"></el-table-column>
			<el-table-column prop="payType" label="购买方式" width="100" align="center">
				<template slot-scope="scope">
					<el-tag v-if='scope.row.payType==1' type='success'>{{'微信支付'}}</el-tag>
					<el-tag v-else-if="scope.row.payType == 2" type='primary'>{{'积分支付'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="orderTotal" label="积分" width="80" align="center">
				<template slot-scope="scope">
					<div>
						<div v-if='scope.row.payType==2'>
							{{ scope.row.orderPointTotal }}
						</div>
						<div v-else>
							{{"-" }}
						</div>
					</div>
				</template>
			</el-table-column> <!-- 订单为积分支付时，orderTotal 表示积分 -->
			<el-table-column prop="amount" label="金额（元）" width="100" align="center">
				<!-- 若后端返回的 orderTotal 单位是“分”，需在表格中转换为元，示例： -->
				<!-- <template slot-scope="scope">{{ (scope.row.orderTotal / 100).toFixed(2) }}</template> -->
			<template slot-scope="scope">
				<div>
					<div v-if='scope.row.payType==1'>
						{{ (scope.row.orderTotal/100).toFixed(2) }}
					</div>
					<div v-else>
						{{"-" }}
					</div>
				</div>
			</template>
			</el-table-column>
			<el-table-column prop="createTime" label="下单时间" width="160" align="center"></el-table-column>
			<el-table-column prop="isFirst" label="是否首次消费" width="80" align="center">
				<template slot-scope="scope">
					<el-tag v-if='scope.row.isFirst' type='success'>{{'是'}}</el-tag>
					<el-tag v-else type='warning'>{{'否'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="consumeSource" label="消费来源" width="120" align="center"></el-table-column>
			<el-table-column prop="pullHewer" label="拉新者" width="120" align="center"></el-table-column>
			<el-table-column prop="pullHewerRatio" label="拉新者提成比例" width="120" align="center"></el-table-column>
			<el-table-column prop="pullHewerAmount" label="拉新者提成金额（元）" width="120"   align="center"></el-table-column>
			<el-table-column prop="shareHewer" label="分享者" width="120" align="center"></el-table-column>
			<el-table-column prop="shareHewerRatio" label="分享者提成比例" width="120" align="center"></el-table-column>
			<el-table-column prop="shareHewerAmount" label="分享者提成金额（元）" width="120" align="center"></el-table-column>
			<el-table-column prop="countAmount" label="总提成金额" width="120" align="center"></el-table-column>
			<el-table-column prop="countRatio" label="总提成比例" width="120" align="center"></el-table-column>
			<el-table-column prop="payTime" label="支付时间" width="160" align="center"></el-table-column>
			<el-table-column prop="orderStatus" label="订单状态" width="120"   align="center">
				<!-- 若需将数字状态转成文字，可在此处用 template 处理，示例： -->
				 <template slot-scope="scope">
<!--					{{ {0:'否',1:'是',2:'已生成预支付订单',3:'订单超时已关闭',4:'订单已退款'}[scope.row.orderStatus] }}-->
					 <el-tag v-if='scope.row.orderStatus==0' type='success'>{{'否'}}</el-tag>
					 <el-tag v-else-if='scope.row.orderStatus==1' type='success'>{{'是'}}</el-tag>
					 <el-tag v-else-if='scope.row.orderStatus==2' type='warning'>{{'已生成预支付订单'}}</el-tag>
					 <el-tag v-else-if='scope.row.orderStatus==3' type='danger'>{{'订单超时已关闭'}}</el-tag>
					 <el-tag v-else-if='scope.row.orderStatus==4' type='info'>{{'订单已退款'}}</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="name"  fixed="right" label="订单详情" width="120" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="showDetail(scope.row)">查看</el-button>
				</template>
			</el-table-column>
			
		</el-table>
		<!--底部工具条-->
		<el-col :span="24" class="pageBar">
			<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageIndex"
					:page-sizes="pages.pageArr"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="pages.dataCount">
			</el-pagination>
		</el-col>
		
		<el-dialog
				title="订单详情"
				:visible.sync="dialogVisible"
				v-model="dialogVisible"
				width="40%"
				center
		>
			<el-table :data="tableData" border style="width: 100%;text-align: center" >
				<el-table-column prop="fileAttribute" label="文件类型" >
					<template slot-scope="scope">
						<el-tag v-if='scope.row.fileAttribute==0' type='success'>{{'主体'}}</el-tag>
						<el-tag v-if='scope.row.fileAttribute==1' type='info'>{{'调查报告'}}</el-tag>
						<el-tag v-else-if="scope.row.fileAttribute == 2" type='primary'>{{'判决书'}}</el-tag>
						<el-tag v-else-if="scope.row.fileAttribute == 3" type='warning'>{{'其它文档'}}</el-tag>
					</template>
					
				</el-table-column>
				<el-table-column prop="fileName" label="产品名称" ></el-table-column>
				<el-table-column prop="productFilePermission" label="产品权限" >
					<template slot-scope="scope">
						<el-tag v-if='scope.row.productFilePermission==1' type='success'>{{'观看'}}</el-tag>
						<el-tag v-if='scope.row.productFilePermission==2' type='warning'>{{'下载'}}</el-tag>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		
	</section>
</template>
<script>
import {
	getRoleListPage,
	addRoleInfo,
	updateRoleInfo,
	deleteRoleInfo,
	getOrganizationTree,
	getOrderProductDeductListPage, getOrderProductDetailList
} from "../../api/api";
import util from "../../../util/date";

import { getButtonList } from "../../promissionRouter";
import Qs from 'qs'
import { useEnterSearch, removeEnterSearch } from '../../../util/enterSearch';
import Toolbar from "../../components/Toolbar.vue";

export default {
	name: "OrderList",
	components: {Toolbar},
	
	data() {
		return {
			// 日期选择器绑定的中间变量（daterange 返回数组，需拆分给 startTime/endTime）
			dateRangePicker: [],
			// 下拉框选项列表（匹配你的业务定义）
			orderTypeList: [
				// 可根据你的实际业务补充选项，示例格式
				{ value: 1, name: '单个产品' },
				{ value: 2, name: '合集产品' }
			],
			yesNoList: [
				{ value: true, name: '是' },
				{ value: false, name: '否' }
			],
			orderSourceList: [
				{ value: 1, name: '自主购买' },
				{ value: 2, name: '他人分享' },
				{ value: 3, name: '系统分享' }
			],
			orderStatusList: [
				{ value: 1, name: '已支付' },
				{ value: 2, name: '待支付' },
				{ value: 3, name: '已关闭' }
			],
			dialogVisible: false,
			tableData: [
			],
			
			utils: '',
			pages: {  //关于分页的obj
				pageSize: 20,//默认每页条数
				pageArr: [10, 20, 30, 40],//默认每页条数选择
				pageIndex: 1, //默认进入页
				dataCount: 20, //默认总页数
			},
			filters: { //顶部筛选条件
				keyWord: undefined,//编号，姓名，手机号,产品标题
				orderType:undefined,//订单类型
				isFirst:undefined,//是否首次
				isCommission:undefined,//是否有提成
				orderSource:undefined,//订单来源：1-自主购买、2-他人分享、3-系统分享
				referrerName:undefined,//推广人昵称
				orderStatus :undefined,//订单状态：1-已支付，2-待支付。3-已关闭
				startTime :undefined,//
				endTime :undefined,//
				
				
			},
			//是否启用状态
			statusList: [{
				value: true,
				name: '启用'
			},{
				value: false,
				name: '禁用'
			}],
			roles: [],//角色信息列表
			currentRow: null,
			listLoading: false,
			buttonList: [],
			
		
		
			
			options: []
		};
	},
	mounted() {
		this.utils = util
		//首次加载角色信息列表
		this.getData();
		let routers = window.localStorage.router  ? JSON.parse(window.localStorage.router) : [];
		this.buttonList = getButtonList(this.$route.path, routers);
		
		// 添加全局回车搜索功能
		useEnterSearch(() => {
			this.getDataList();
		});
	},
	beforeDestroy() {
		// 移除全局回车监听
		removeEnterSearch();
	},
	methods: {
		handleDateRangeChange(val) {
			if (val && val.length === 2) {
				this.filters.startTime = val[0];
				this.filters.endTime = val[1];
			} else {
				this.filters.startTime = undefined;
				this.filters.endTime = undefined;
			}
		},
		showDetail(row){
			let params = {
				orderInfoId:row.id
			};
			getOrderProductDetailList(params).then(res => {
				if (res.data.success) {
					this.tableData = res.data.response;
					this.dialogVisible = true;
				}else{
					this.$message({
						message: res.data.message,
						type: 'error'
					});
				}
			});
			
			console.log(row)
		},
		//
		selectCurrentRow(val) {
			this.currentRow = val;
		},
		//获取角色信息分页列表
		getData() {
			let _this = this;
			let params = {
				pageIndex: this.pages.pageIndex,
				pageSize: this.pages.pageSize,
				keyWord: this.filters.keyWord, // 编号，姓名，手机号,产品标题
				orderType: this.filters.orderType, // 订单类型
				isFirst: this.filters.isFirst, // 是否首次
				isCommission: this.filters.isCommission, // 是否有提成
				orderSource: this.filters.orderSource, // 订单来源：1-自主购买、2-他人分享、3-系统分享
				referrerName: this.filters.referrerName, // 推广人昵称
				orderStatus: this.filters.orderStatus, // 订单状态：1-已支付，2-待支付。3-已关闭
				startTime: this.filters.startTime, // 开始日期
				endTime: this.filters.endTime // 结束日期
			};
			
			this.listLoading = true;
			getOrderProductDeductListPage(params).then(res => {
				this.roles = res.data.response.data;
				this.listLoading = false;
				this.pages.dataCount = res.data.response.dataCount
				this.pages.pageIndex = res.data.response.pageIndex
				if(res.data.response.pageSize > 0){
					this.pages.pageSize = res.data.response.pageSize
				}
			});
		},
		// 分页
		handleCurrentChange(val) {
			// if(this.filters.name != '' || this.filters.selectc != true){
			//   this.pages.pageIndex = 1
			// }else{
			this.pages.pageIndex = val;
			// }
			this.getData();
		},
		handleSizeChange(val){
			this.pages.pageSize = val
			this.getData();
		},
		callFunction(item) {
			this[item.func].apply(this, item);
		},
		//时间格式化
		formatCreateTime: function(row, column) {
			return !row.createTime || row.createTime == ""
					? ""
					: util.formatDate.format(new Date(row.createTime), "yyyy-MM-dd");
		},
	
		
		// 查询
		getDataList(){
			this.pages.pageIndex = 1
			this.getData()
		},
		
		// 表格数据分页条数累计
		indexMethod(index) {
			var currentPage = this.pages.pageIndex
			var pageSize = this.pages.pageSize
			return (index + 1) + (currentPage - 1) * pageSize
		},
	}
};
</script>
<style lang="stylus" scoped>
.rolesTop{
	width 100%;
	display flex;
}
.rolesInp{
	width 300px;
	margin-right 20px;
}
.pageBar{
	margin-top 15px;
}
.bold-font {
	font-weight: bold;
}
</style>